<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="authors-note">
<h1>Author’s Note</h1>
<p>The Gullah-Geechee people originally came from western/central Africa and have lived in the low country of South Carolina and Georgia since the colonization of America. They are fascinating and personable; holding strong to their beliefs, heritage, traditions and language. They speak a sea island ‘creole’ which is a combination of African/English.</p>
<p>This novel has some conversations using the ‘Gullah’ and ‘Geechee’ languages, but it’s not completely authentic. It was written in a manner to be more understandable to the reader.</p>
<p>The author respects the ways, customs and the language of the Gullah-Geechee people.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?1aeecb5a